export default __webpack_public_path__ + "static/media/gaming_Footer_Opus_Supplier.455057b0.svg";